import { Box } from '@mui/material';
import { Children, ReactNode } from 'react';

export const Timeline = ({ children }: { children: ReactNode }) => {
    const childrenArray = Children.toArray(children);
    return (
        <Box position="relative" display="flex" flexDirection="column" mr={2} minWidth="32px">
            {childrenArray.map((child, idx) => (
                <Box key={idx} position="relative">
                    {/* Vertical line for all except the last item */}
                    {idx !== childrenArray.length - 1 && (
                        <Box
                            position="absolute"
                            top={0}
                            bottom={0}
                            mt={1}
                            left="20px"
                            sx={{
                                width: '2px',
                                bgcolor: '#E2E8F0',
                                transform: 'translateX(-50%)',
                                zIndex: 0
                            }}
                        />
                    )}
                    {child}
                </Box>
            ))}
        </Box>
    );
};

type TimelineIconProps = {
    borderColor: string;
    backgroundColor: string;
    icon: React.ReactNode;
    iconFontSize?: string | number;
    iconWidth?: string | number;
    marginLeft?: string | number;
};

export const TimelineIcon: React.FC<TimelineIconProps> = ({
    borderColor,
    backgroundColor,
    icon,
    iconFontSize,
    iconWidth = 40,
    marginLeft = 0
}) => (
    <Box
        sx={{
            width: iconWidth,
            height: iconWidth,
            border: '2px solid',
            borderColor: borderColor,
            borderRadius: '50%',
            backgroundColor: backgroundColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
            marginLeft: marginLeft
        }}
    >
        <Box
            component="span"
            sx={{
                color: borderColor,
                fontSize: iconFontSize,
                display: 'flex',
                alignItems: 'center'
            }}
        >
            {icon}
        </Box>
    </Box>
);
